/* Controlled Insanity — Early Access landing (Shopify OS 2.0). Dependency-free.
   Uses document-level event delegation, so it survives Theme Editor section re-renders. */
(function () {
  if (window.__ciLanding) return;
  window.__ciLanding = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* ---------- FAQ accordion ---------- */
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var q = item.querySelector('.ci-faq__q');
    if (q) q.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('.ci-lp .ci-faq__q');
    if (q) { var item = q.closest('.ci-faq__item'); setOpen(item, !item.classList.contains('is-open')); return; }

    /* Founder video: first tap unmutes, then toggles play / pause */
    var v = e.target.closest && e.target.closest('.ci-lp .ci-video video');
    if (v) {
      if (v.muted) { v.muted = false; v.play(); }
      else if (v.paused) v.play(); else v.pause();
    }
  });

  /* ---------- Founder video ---------- */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'VIDEO' && t.closest('.ci-lp')) t.closest('.ci-video').classList.add('is-empty');
  }, true);
  function initVideos(root) {
    (root || document).querySelectorAll('.ci-lp .ci-video video').forEach(function (v) {
      var box = v.closest('.ci-video');
      if (!v.getAttribute('src') || v.error) { box.classList.add('is-empty'); return; }
      box.classList.remove('is-empty');
      v.muted = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initVideos(); });
  else initVideos();

  /* ---------- Theme Editor hooks ---------- */
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('.ci-faq__item');
    if (item) setOpen(item, true);
  });

  /* ---------- Sign-up forms (Shopify {% form 'customer' %}) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var wrap = f.closest && f.closest('.ci-lp [data-ci-form]');
    if (!wrap) return;
    e.preventDefault();

    var btn = f.querySelector('button[type="submit"]');
    var label = btn.querySelector('[data-label]') || btn;
    var email = f.querySelector('input[type="email"]');
    var phone = f.querySelector('input[type="tel"]');
    var consent = f.querySelector('input[type="checkbox"]');
    var ok = true;

    [email, phone, consent].forEach(function (el) { if (el) el.classList.remove('is-invalid'); });
    if (!EMAIL_RE.test((email.value || '').trim())) { email.classList.add('is-invalid'); ok = false; }
    if (phone && phone.value.trim() && phone.value.replace(/\D/g, '').length < 10) { phone.classList.add('is-invalid'); ok = false; }
    if (phone && phone.value.trim() && consent && !consent.checked) { consent.classList.add('is-invalid'); ok = false; }
    if (!ok) { (f.querySelector('.is-invalid') || email).focus(); return; }

    /* Copy phone into the customer note so it is stored even if the theme ignores contact[phone] */
    var note = f.querySelector('input[name="contact[note]"]');
    if (note && phone) note.value = phone.value.trim() ? 'Phone: ' + phone.value.trim() + (consent && consent.checked ? ' | SMS consent: yes' : '') : '';

    var discord = wrap.getAttribute('data-discord-url');
    var win = discord ? window.open('', '_blank') : null; // opened synchronously to avoid popup blockers
    var original = label.innerHTML;
    var successText = wrap.getAttribute('data-success') || 'You’re on the list';
    btn.disabled = true; label.textContent = 'Submitting…';

    function done(success) {
      btn.disabled = false;
      if (success) {
        label.textContent = successText;
        f.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"])').forEach(function (i) { i.value = ''; });
        if (consent) consent.checked = false;
        if (win) win.location.href = discord;
      } else {
        if (win) win.close();
        label.textContent = 'Something went wrong — try again';
      }
      setTimeout(function () { label.innerHTML = original; }, success ? 5000 : 3500);
    }

    var isShopify = !!(window.Shopify && window.Shopify.shop);
    if (!isShopify || (window.Shopify && window.Shopify.designMode)) { setTimeout(function () { done(true); }, 400); return; }

    fetch(f.getAttribute('action') || '/contact', {
      method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' }, credentials: 'same-origin'
    }).then(function (r) {
      /* Shopify may redirect to /challenge (hCaptcha). Fall back to a normal submit in that case. */
      if (r.redirected && /challenge/.test(r.url)) { if (win) win.close(); f.submit(); return; }
      done(r.ok);
    }).catch(function () { done(false); });
  });
})();
